import { useWpLayout } from '@pets-ui/useWpLayout/useWpLayout'
import { jwtDecode } from 'jwt-decode'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useRequestUser } from '../../../hooks/apis/wp/useRequestUser'
import { getXPlatformToken } from '../../../utils/cookie'
import { wordPressNavigate } from '../../../utils/wordPressRoute'
import { useContextCosign } from '../../useContextCosign'
import { CardLogin } from '../CardLogin'
import { BindStep } from '../login/types'
import { Service } from '../Service'
import { BindEmail } from './BindEmail'
import { BindEmailValidation } from './BindEmailValidation'

export function BindEmailPortal() {
  const { t } = useTranslation()
  const { title } = useContextCosign()
  const { destructuredData: user } = useRequestUser(undefined, { shouldRetryOnError: false })
  const xPlatformToken = getXPlatformToken()
  const decoded = xPlatformToken ? jwtDecode<{ platformUid?: string }>(xPlatformToken) : null

  const [step, setStep] = useState(BindStep.INPUT_ACCOUNT)
  const [email, setEmail] = useState('')
  useWpLayout({ footer: false })

  useEffect(() => {
    if (user?.platformUserProfile.email) wordPressNavigate('/my-account/edit-account/')
    if (!decoded?.platformUid) wordPressNavigate('/my-account/')
  }, [decoded?.platformUid, user?.platformUserProfile.email])

  return (
    <CardLogin>
      <Helmet>
        <title>
          {t('login.verifyIdentity')}
          {' '}
          -
          {' '}
          {title}
        </title>
      </Helmet>
      {step === BindStep.INPUT_ACCOUNT
      && <BindEmail email={email} setEmail={setEmail} setStep={setStep} />}
      {step === BindStep.VALIDATE
      && <BindEmailValidation email={email} setStep={setStep} />}
      <Service />
    </CardLogin>
  )
}
